import dayjs from 'dayjs'
import { AssignmentStatusColor } from '../types'

type AssignmentStatistics = {
  totalUsers?: number
  completedUsers?: number
}

export function getProgressColor(
  completionRate: number,
  isOverdue: boolean,
): AssignmentStatusColor {
  if (completionRate === 100) return 'success'
  if (isOverdue) return 'error'
  if (completionRate > 50) return 'primary'
  return 'warning'
}

export function getIsOverdue(dueDate: string): boolean {
  return Boolean(dueDate && dayjs(dueDate).isBefore(dayjs(), 'day'))
}

export function getCompletionRate(
  statistics?: AssignmentStatistics | null,
): number {
  let { totalUsers = 0, completedUsers = 0 } = statistics ?? {}
  return totalUsers > 0 ? Math.round((completedUsers / totalUsers) * 100) : 0
}
